module.exports = __webpack_public_path__ + "static/media/guidance_instructions.81c301ad.pdf";